<template>
    <div v-if="sessionLoaded">
        <b-row>
            <b-col class="text-center">
                <button v-if="step >= 2" :disabled="loading" class="btn btn-warning float-sm-right mt-3 mb-3" @click="restart()">
                    <i class="fas fa-undo"></i> Erneut testen
                </button>
            </b-col>
        </b-row>

        <message-banner
            title="Aktuell hohe Auslastung"
            message="Die Demofunktion wird aktuell stark genutzt. Bitte versuchen Sie es später erneut."
            variant="warning"
            icon="fas fa-exclamation-circle"
            :close="true"
            v-if="limitReached"
            @close="limitReached=false"
        ></message-banner>

        <message-banner
            title="Fehler aufgetreten"
            message="Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut."
            variant="error"
            icon="fas fa-exclamation-circle"
            :close="true"
            v-if="errorOccurred"
            @close="errorOccurred=false"
        ></message-banner>

        <div v-if="step >= 0">
            <h4 class="card-title">
                <span class="font-weight-bold" style="font-size: 3rem;">1.</span> Wart's Ab App herunterladen
            </h4>
            <p>Nutzen Sie einen der beiden Buttons, um zu Ihrem jeweiligen Store zu gelangen oder diesen QR-Code.</p>
            <b-row align-v="center" class="text-center">
                <b-col>
                    <a :href="iosStoreLink" target="_blank">
                        <img :src="iosStoreImg" class="w-100" style="max-width: 150px">
                    </a>
                    <a :href="androidStoreLink" target="_blank">
                        <img :src="androidStoreImg" class="w-100" style="max-width: 150px"></a>
                </b-col>
                <b-col>
                    <img :src="downloadQr" style="max-width: 100%; width: 150px">
                </b-col>
            </b-row>

            <div v-if="step===0" class="text-center">
                <button class="btn btn-warning mt-4" @click="step++"><i class="fas fa-chevron-down"></i> Weiter</button>
            </div>
        </div>
        <div v-if="step >= 1">
            <hr>
            <h4 class="card-title">
                <span class="font-weight-bold" style="font-size: 3rem;">2.</span> Wart's Ab ID erstellen (Wartenummer)
            </h4>
            <p>Aus Sicherheitsgründen bitte das hCaptcha lösen.</p>
            <b-overlay :show="loading && step === 1" rounded="sm">
                <vue-hcaptcha v-if="step === 1" class="mb-3" :sitekey="hcaptchaSitekey"
                              @verify="onVerify"></vue-hcaptcha>

                <message-banner
                    title="hCaptcha gelöst"
                    variant="success"
                    icon="fas fa-check-circle"
                    v-else
                ></message-banner>
            </b-overlay>
        </div>
        <div v-if="step >= 2">
            <hr>
            <h4 class="card-title">
                <span class="font-weight-bold" style="font-size: 3rem;">3.</span> Wart's Ab ID in der Wart's Ab App eintragen
            </h4>
            <p>Scannen oder manuell eintragen.</p>
            <b-overlay :show="loading && step === 2" rounded="sm">

                <div>
                    <b-row>
                        <b-col class="text-center" cols="12" sm="6">
                            <strong class="font-weight-bold" style="font-size: 2rem;">
                                {{ waiter.activation_code }}
                            </strong><br>
                            <qrcode-vue :value="JSON.stringify(qrCode)" level="L" size="150"></qrcode-vue>

                            <p v-if="timeToExpire.totalSeconds>0"><i class="far fa-hourglass"></i> Gültig für:
                                {{ timeToExpire.minutes }} min. {{ timeToExpire.seconds }} sec.</p>
                            <p v-else><i class="far fa-hourglass"></i> Aktivierungszeit abgelaufen</p>
                        </b-col>

                        <b-col cols="12" sm="6">
                            <b-row>
                                <b-col>
                                    <b-form-group
                                        description="Zeit, in der man in der Praxis/Klinik ist"
                                        label="Wegezeit"
                                        label-for="traveltime"
                                    >
                                        <b-input-group :append="qrCodeMetadata.timePeriod+' min.'">
                                            <b-form-input id="traveltime" v-model="qrCodeMetadata.timePeriod"
                                                          :disabled="!(timeToExpire.totalSeconds>0)" max="60" min="5"
                                                          step="5" type="range"></b-form-input>
                                        </b-input-group>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col cols="12" md="6">
                                    <b-form-group
                                        description="optional (verbleibt nur in der App)"
                                        label="Vorname"
                                        label-for="firstname"
                                    >
                                        <b-form-input
                                            id="firstname"
                                            v-model="qrCodeMetadata.fn"
                                            :disabled="!(timeToExpire.totalSeconds>0)"
                                            debounce="100"
                                            placeholder="Max"
                                            trim
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group
                                        description="optional (verbleibt nur in der App)"
                                        label="Nachname"
                                        label-for="lastname"
                                    >
                                        <b-form-input
                                            id="lastname"
                                            v-model="qrCodeMetadata.ln"
                                            :disabled="!(timeToExpire.totalSeconds>0)"
                                            debounce="100"
                                            placeholder="Mustermann"
                                            trim
                                        ></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <div class="text-center">
                        <p>Prüfen Sie jetzt, ob die Eintragung erfolgreich war</p>
                        <button v-if="step===2" :disabled="loading" class="btn btn-warning" @click="loadWaiterData">
                            <i class="fas fa-check-circle"></i> Eintragung erfolgreich?
                        </button>
                        <message-banner
                            title="Wart's Ab ID erfolgreich überprüft"
                            variant="success"
                            icon="fas fa-check-circle"
                            v-else
                        ></message-banner>
                    </div>
                </div>
            </b-overlay>
        </div>
        <div v-if="step >= 3">
            <hr>
            <h4 class="card-title">
                <span class="font-weight-bold" style="font-size: 3rem;">4.</span> Benachrichtigung versenden
            </h4>
            <div class="text-center">
                <b-overlay :show="loading" rounded="sm">

                    <message-banner
                        title="Benachrichtung erfolgreich versendet"
                        message="Auf Ihrem Smartphone erscheint jetzt der Aufruf."
                        variant="success"
                        icon="fas fa-check-circle"
                        v-if="waiter.notification_send!=null"
                    ></message-banner>
                    <div v-else-if="waiter.notification_requested!=null">
                        <message-banner
                            title="Benachrichtung wird versendet"
                            variant="info"
                            icon="fas fa-clock"
                        ></message-banner>
                        <button :disabled="loading" class="btn btn-warning mt-3" @click="loadWaiterData"><i
                            class="fas fa-sync"></i> Status aktualisieren
                        </button>
                    </div>
                    <button v-else :disabled="loading" class="btn btn-warning" @click="notify"><i
                        class="fas fa-bell"></i> Benachrichtung versenden
                    </button>
                </b-overlay>
            </div>
        </div>
    </div>
    <div v-else class="d-flex justify-content-center mb-3">
        <b-spinner></b-spinner>
    </div>



</template>

<script>

import VueHcaptcha from '@hcaptcha/vue-hcaptcha';
import QrcodeVue from 'qrcode.vue';
import MessageBanner from "./MessageBanner";

export default {
    components: {VueHcaptcha, QrcodeVue,MessageBanner},

    props: [
        'iosStoreLink',
        'androidStoreLink',
        'iosStoreImg',
        'androidStoreImg',
        'downloadQr',
        'hcaptchaSitekey'
    ],

    computed: {
        qrCode: function () {
            return {
                wa: "Wart's Ab QRCode",
                ac: this.waiter.activation_code,
                doc: '',
                timePeriod: this.qrCodeMetadata.timePeriod,
                reason: '',
                o: "Wart's Ab Demo",
                ln: this.qrCodeMetadata.ln,
                ti: '',
                fn: this.qrCodeMetadata.fn,
            };
        },


    },

    data: function () {
        return {
            interval: null,
            step: 0,
            loading: false,
            sessionLoaded: false,
            waiter: null,
            qrCodeMetadata: {
                timePeriod: 15,
                ln: '',
                fn: ''
            },
            timeToExpire: {
                totalSeconds: null,
                minutes: null,
                seconds: null,
            },
            limitReached: false,
            errorOccurred: false
        }
    },
    methods: {
        updateDiffs: function () {
            if (this.waiter && this.waiter.created_at) {
                this.timeToExpire.totalSeconds = this.$date.utc(this.waiter.created_at).add(5, 'minute').diff(this.$date.utc(), 'second');
                this.timeToExpire.minutes = Math.floor(this.timeToExpire.totalSeconds / 60);
                this.timeToExpire.seconds = this.timeToExpire.totalSeconds % 60;
            } else {
                this.timeToExpire.totalSeconds = null;
                this.timeToExpire.minutes = null;
                this.timeToExpire.seconds = null;
            }
        },

        submit: function (evt) {
            evt.preventDefault();
            console.log(evt);
        },
        onVerify: function (response) {
            this.errorOccurred = false;
            this.loading = true;
            axios.post('/demo', {
                "h-captcha-response": response
            })
                .then((response) => {
                    this.waiter = response.data.data;
                    this.updateDiffs();
                    this.step = 2;
                    this.limitReached = false;
                })
                .catch((error) => {
                    console.log(error.response);
                    if(error.response.status === 503){
                        this.limitReached = true;
                        this.step = 0;
                    }
                    else{
                        this.errorOccurred = true;
                        this.step = 0;
                    }
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        notify: function () {
            this.loading = true;
            axios.post('/demo/notify')
                .then((response) => {
                    if (response.status === 200) {
                        this.waiter = response.data.data;
                    }
                    else{
                        this.loadWaiterData();
                    }
                })
                .catch(function (error) {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        reset: function () {
            this.waiter = null;
            this.qrCodeMetadata = {
                timePeriod: 15,
                ln: '',
                fn: ''
            };
            this.step = 0;
            this.loading = false;
        },

        restart: function () {
            this.loading = true;
            axios.delete('/demo')
                .then((response) => {
                    this.reset();
                })
                .catch((error) => {
                    console.log(error);
                    this.reset();
                });
        },

        loadWaiterData: function () {
            this.loading = true;
            axios.get('/demo')
                .then((response) => {
                    this.sessionLoaded = true;
                    if (response.status === 204) {
                        this.reset();
                    } else {
                        this.loading = false;
                        this.waiter = response.data.data;
                        if (this.waiter.activation_code !== undefined) {
                            if (this.waiter.subscribed_for_push)
                                this.step = 3;
                            else {
                                this.updateDiffs();
                                this.step = 2;
                            }
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.errorOccurred = true;
                    this.reset();
                });
        },
    },

    mounted() {
        this.loadWaiterData();
        this.interval = setInterval(() => {
            this.updateDiffs();
        }, 1000);

        this.updateDiffs();
    },
    destroyed() {
        clearInterval(this.interval);
    }
}
</script>
